import { DropdownGroup, IDropdownGroupProps } from './DropdownGroup';
import { DropdownItem, IDropdownItemProps } from './DropdownItem';
import * as React from 'react';

export type TDropdownElementProps = IDropdownItemProps | IDropdownGroupProps;

export const isDropdownGroupProps = (item: TDropdownElementProps): item is IDropdownGroupProps => 'items' in item;

export interface IDropdownItemOrGroupProps {
  item: TDropdownElementProps;
}

export const DropdownItemOrGroup: React.FC<IDropdownItemOrGroupProps> = ({ item }) =>
  isDropdownGroupProps(item) ? <DropdownGroup {...item} /> : <DropdownItem {...item} />;
